module.exports = __webpack_public_path__ + "img/different.622f1aaa.jpg";